import React, { useEffect, useState } from 'react';
import './Pagination.light.scss';
import './Pagination.dark.scss';

const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';

const range = (from: number, to: number, step = 1) => {
  let i = from;
  const pageRange = [];

  while (i <= to) {
    pageRange.push(i);
    i += step;
  }

  return pageRange;
};

const Pagination = (props: any) => {
  let { totalRecords, pageLimit, pageNeighbors } = props;

  pageLimit = typeof pageLimit === 'number' ? pageLimit : 30;
  totalRecords = typeof totalRecords === 'number' ? totalRecords : 0;

  pageNeighbors =
    typeof pageNeighbors === 'number'
      ? Math.max(0, Math.min(pageNeighbors, 2))
      : 0;

  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(totalRecords / pageLimit);
  const { onPageChanged } = props;
   
  const goToPage = (page: number) => {
    const currentPage = Math.max(0, Math.min(page, totalPages));

    const paginationData = {
      currentPage,
      totalPages: totalPages,
      pageLimit: pageLimit,
      totalRecords: totalRecords,
    };

    setCurrentPage(currentPage);
    onPageChanged(paginationData);
  };
   
  useEffect(() => {
    goToPage(1);
  }, [totalRecords]);

  const handleClick = (page: any, event: any) => {
    event.preventDefault();
    goToPage(page);
  };

  const handleMoveLeft = () => {
    goToPage(currentPage - pageNeighbors * 2 - 1);
  };

  const handleMoveRight = () => {
    goToPage(currentPage - pageNeighbors * 2 + 1);
  };

  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbors * 2 + 3;
    const totalBlocks = totalNumbers + 2;

    if (totalPages > totalBlocks) {
      let pages = [];

      const leftBound = currentPage - pageNeighbors;
      const rightBound = currentPage + pageNeighbors;
      const beforeLastPage = totalPages - 1;

      const startPage = leftBound > 2 ? leftBound : 2;
      const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;

      pages = range(startPage, endPage);

      const pagesCount = pages.length;
      const singleSpillOffset = totalNumbers - pagesCount - 1;

      const leftSpill = startPage > 2;
      const rightSpill = endPage < beforeLastPage;

      const leftSpillPage = LEFT_PAGE;
      const rightSpillPage = RIGHT_PAGE;

      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1);
        pages = [leftSpillPage, ...extraPages, ...pages];
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset);
        pages = [...pages, ...extraPages, rightSpillPage];
      } else if (leftSpill && rightSpill) {
        pages = [leftSpillPage, ...pages, rightSpillPage];
      }

      return [1, ...pages, totalPages];
    }

    return range(1, totalPages);
  };

  if (!totalRecords) {
return null;
}

  if (totalPages === 1) {
return null;
}

  const pages = fetchPageNumbers();

  return (
    <div className='pagination-wrapper'>
      <div className='pagination-info'>
        <p>
          Showing {currentPage * pageLimit - pageLimit + 1} -
          {totalRecords > currentPage * pageLimit
            ? currentPage * pageLimit
            : totalRecords}{' '}
          of {totalRecords} Sessions
        </p>
      </div>
      <nav
        aria-label='Countries Pagination'
        className='pagination-button-container'
      >
        <ul className='pagination'>
          {pages.map((page, index) => {
            if (page === LEFT_PAGE) {
return (
                <li
key={index}
className='page-item'>
                  <a
                    className='page-link'
                    href='#'
                    aria-label='Previous'
                    onClick={handleMoveLeft}
                  >
                    <span aria-hidden='true'>&laquo;</span>
                  </a>
                </li>
              );
}

            if (page === RIGHT_PAGE) {
return (
                <li
key={index}
className='page-item'>
                  <a
                    className='page-link'
                    href='#'
                    aria-label='Next'
                    onClick={handleMoveRight}
                  >
                    <span aria-hidden='true'>&raquo;</span>
                  </a>
                </li>
              );
}

            return (
              <li
                key={index}
                className={`page-item${currentPage === page ? ' active' : ''}`}
              >
                <a
                  className='page-link'
                  href='#'
                  onClick={(e) => handleClick(page, e)}
                >
                  {page}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
